/**
 * browserOnly — wraps a callback so it only executes in a browser
 * environment (where `window` is defined).
 *
 * Use for code paths shared between client and SSR/Node entry points
 * that should only run in the browser: DOM listeners, localStorage
 * access, URL flag reading, etc.
 *
 * Blueprint #10 Session C.
 */
export function browserOnly<T>(fn: () => T): T | undefined {
  return typeof window !== 'undefined' ? fn() : undefined;
}
